/**
 * PhaseMoralSummary — banner de cupo + finalize.
 *
 * Llama a ``GET /api/customer-drafts/{draftId}/finalize-preview`` vía
 * el ``FinalizePreviewBanner``, deshabilita "Finalizar" si hay blockers
 * de plan, y maneja correctamente el 409 cuando el backend rechaza el
 * finalize por cupo (cinturón de seguridad encima del tirante).
 */
import React, { useCallback, useState } from "react";
import { Button } from "../ui/button";
import { toast } from "sonner";
import FinalizePreviewBanner from "./FinalizePreviewBanner";

export default function PhaseMoralSummary({ onFinalize, onBack, loading, draftId }) {
  const [quotaOk, setQuotaOk] = useState(true);
  const onQuota = useCallback(({ ok }) => setQuotaOk(ok), []);

  const handleFinalize = async () => {
    try {
      await onFinalize();
    } catch (e) {
      const status = e.response?.status;
      const detail = e.response?.data?.detail;
      if (status === 409 && detail && typeof detail === "object" && detail.blockers) {
        toast.error("Tu plan no alcanza para finalizar este expediente.", {
          description: detail.blockers.map((b) => `${b.label}: ${b.detail}`).join(" · "),
        });
      } else if (status === 502) {
        toast.error("Falló el screening. Vuelve a intentar; el expediente no se creó.");
      } else {
        toast.error("No se pudo finalizar el expediente", {
          description: typeof detail === "string" ? detail : "Error desconocido.",
        });
      }
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-white mb-1">Confirmar y finalizar</h2>
        <p className="text-sm text-slate-400">
          Revisa el resumen del expediente y el consumo que tendrá en tu plan antes de finalizar.
        </p>
      </div>

      <FinalizePreviewBanner draftId={draftId} onQuotaChange={onQuota} />

      <div className="flex justify-between pt-4">
        <Button variant="outline" onClick={onBack} disabled={loading}>← Atrás</Button>
        <Button
          data-testid="moral-finalize-btn"
          disabled={!quotaOk || loading}
          onClick={handleFinalize}
          className="bg-teal-600 hover:bg-teal-700 text-white"
        >
          {loading ? "Finalizando…" : "Finalizar expediente →"}
        </Button>
      </div>
    </div>
  );
}
